// removed by extract-text-webpack-plugin
module.exports = {"oddsButton":"gapY54nP9wI0zQqQIB4BE","checked":"_2g0ICifLaE3qeAXY6BAeHF","disabled":"_2gsh422ogTP7f5Rgyr3xWf","selected":"_3IfTm2vdRs56oQchO0nSv3"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/modules/basketball/css/oddsButton.css
// module id = 763
// module chunks = 0